export const getAuthToken = (): string | null => localStorage.getItem('crowdtrades_token');

export const buildAuthHeaders = (
  _userOrId?: unknown,
  extraHeaders: Record<string, string> = {}
): Record<string, string> => {
  const token = getAuthToken();
  return token ? { ...extraHeaders, Authorization: `Bearer ${token}` } : { ...extraHeaders };
};

export const buildJsonAuthHeaders = (
  userOrId?: unknown,
  extraHeaders: Record<string, string> = {}
): Record<string, string> => buildAuthHeaders(userOrId, { 'Content-Type': 'application/json', ...extraHeaders });

export const installAuthenticatedFetch = (): void => {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = ((input: RequestInfo | URL, init: RequestInit = {}) => {
    const headers = new Headers(init.headers);
    headers.delete('x-user-id');
    const token = getAuthToken();
    if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    return nativeFetch(input, { ...init, headers });
  }) as typeof window.fetch;
};
